export default "__VITE_ASSET__Cgbx$nX2__"